import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { TOAST_TYPES } from '@/plugins/ed-toast/values/ed-toast.values';

interface ShortDayOption {
  text: string;
  value: string;
}

@Component({})
export default class EdClassScheduleShortDaysModal extends Vue {
  @Prop({ type: Function, required: true }) readonly onAddShortDay!: (shortDay: string) => void;
  @Prop({ type: String }) readonly scheduleShortDay!: string;
  @Prop({ type: Array}) readonly workingDays!: string[];

  public selectedShortDay: string = this.scheduleShortDay || '';
  public isSaving = false;

  get shortDayOptions(): ShortDayOption[] {
    return this.workingDays.map(day => ({
      text: this.$t(`common.weekdays.${day.toLocaleLowerCase()}`) as string,
      value: day.toUpperCase()
    }));
  }

  public async addShortDay(): Promise<void> {
    try {
      if (this.selectedShortDay) {
        this.isSaving = true;
        await this.onAddShortDay(this.selectedShortDay);
      }
      this.isSaving = false;
      this.$EdModal.closeModal();
    } catch (error) {
      this.$EdToast.create({
        msg: this.$t('tools.classBuilder.errorSavingShortDay') as string,
        type: TOAST_TYPES.DANGER,
        timeout: 3000
      });
    }
  }

  public cancelSelection(): void {
    this.$EdModal.closeModal();
  }

  mounted() {
    if (this.scheduleShortDay) {
      this.selectedShortDay = this.scheduleShortDay;
    }
  }
}
